import React from 'react';
import { FunctionField, useRecordContext } from 'react-admin';
import { DisplayHelpers } from 'utils/helpers';
import BlendedRateField from './BlendedRateField';
import { RateSettingsDisplayHelper } from 'utils/displayHelpers/rate-settings';

export const ChargeRateCentsField = ({
  isLocationTypePositionRateSetting,
  nestedOperator,
  isLocationPositionRateSetting,
}) => {
  const record = useRecordContext();
  const { settings, location, non_blended_settings_charge_rate } = record;
  const { ten99, w2 } = settings;
  const rateSettingsDisplayHelper = new RateSettingsDisplayHelper({ settings, location });
  const activeRate = rateSettingsDisplayHelper.getActiveRate(nestedOperator);
  const chargeRateCents = rateSettingsDisplayHelper.getActiveChargeRateCents(nestedOperator);

  const isBlended = activeRate === 'blended-rate';
  const showBlendedRate = isBlended && !isLocationPositionRateSetting;

  if (
    !ten99?.charge_rate_cents &&
    !w2?.local?.charge_rate_cents &&
    !w2?.travel?.charge_rate_cents
  ) {
    return null;
  }

  if (isLocationTypePositionRateSetting) {
    return (
      <FunctionField
        render={() => {
          const isW2 = nestedOperator.includes('w2');

          const { w2_local_with_location_type_markup, ten99_with_location_type_markup } =
            non_blended_settings_charge_rate;

          return DisplayHelpers.money(
            isW2 ? w2_local_with_location_type_markup : ten99_with_location_type_markup,
          );
        }}
      />
    );
  }

  if (chargeRateCents) {
    if (showBlendedRate) {
      return <BlendedRateField />;
    }
    return <FunctionField render={() => DisplayHelpers.money(chargeRateCents)} />;
  }
};

ChargeRateCentsField.defaultProps = {
  label: 'Location Rate',
};
